export default "__VITE_ASSET__DK02ZuqJ__"